/* Version Number Directive
 *
 * Angular Module: trackerbase-app.directives.version-number
 * Directive exposed as "tb-version-number" element.
 */
import angular from "angular";
import Assert from "tbAssert";

import CurrentTBVersion from "../config/CurrentTbVersion";

const versionNumberString = `${CurrentTBVersion.major}.${CurrentTBVersion.minor}.${CurrentTBVersion.patch}`;
const versionLabel = `${CurrentTBVersion.label}`;

const simplifierParamsTable = Object.freeze({
    dev: {
        re: /-dev.\d+(?:\+[0-9a-f]{0,7})?/,
        displayParams: {
            label: "dev",
            separator: "-"
        }
    },
    release: {
        re: /\+rel\.\d+(?:\.[0-9a-f]{0,7})?/,
        displayParams: {
            label: "rel",
            separator: "+"
        }
    }
});

const versionLabelData = function (rawVersionLabel) {
    let versionLabelParams = {
        simpleLabel: rawVersionLabel,
        fullLabel: rawVersionLabel,
        separator: "-"
    };

    let paramLookup = null;
    if (simplifierParamsTable.release.re.test(rawVersionLabel)) {
        paramLookup = simplifierParamsTable.release.displayParams;
    }
    else if (simplifierParamsTable.dev.re.test(rawVersionLabel)) {
        paramLookup = simplifierParamsTable.dev.displayParams;
    }

    if (paramLookup != null) {
        versionLabelParams.simpleLabel = paramLookup.label;
        versionLabelParams.fullLabel = rawVersionLabel.slice(1);
        versionLabelParams.separator = paramLookup.separator;
    }

    return versionLabelParams;
}(versionLabel);

function computeVersionDisplayString({
    showVersionNumber: showVNum,
    showVersionLabel: showVLbl,
    useSimplifiedLabel: useSimpleLabel
}) {
    let vDisplayElems = [];
    const vDisplaySeparator = versionLabelData.separator;

    if (showVNum) {
        vDisplayElems.push(versionNumberString);
    }

    if (showVLbl) {
        if (useSimpleLabel) {
            vDisplayElems.push(versionLabelData.simpleLabel);
        }
        else {
            vDisplayElems.push(versionLabelData.fullLabel);
        }
    }

    return vDisplayElems.join([vDisplaySeparator]);
}


const mLogSvc = new WeakMap();
const mScopeSvc = new WeakMap();
const mVersionDisplayString = new WeakMap();

const mShowVersionNumber = new WeakMap();
const mShowVersionLabel = new WeakMap();
const mUseSimplifiedVersionLabel = new WeakMap();

class VersionNumberComponentController {
    constructor($scope, $log) {
        Assert.StrictAssert($scope != null, "Assertion Failure in Version Number Component: Missing or Invalid Scope Service Dependency");
        Assert.StrictAssert($log != null, "Assertion Failure in Version Number Component: Missing or Invalid Log Service Dependency");

        mScopeSvc.set(this, $scope);
        mLogSvc.set(this, $log);
    }

    $onInit() {
        mLogSvc.get(this).debug("In Version Number Component Init!");
        this._recalculateVersionDisplayString();

        const scopeSvc = mScopeSvc.get(this);

        scopeSvc.$watchGroup([
                () => this.showVersionNumber,
                () => this.showVersionLabel,
                () => this.useSimpleVersionLabel
            ],
            (newValues, oldValues) => {
                if (!angular.equals(newValues, oldValues)) {
                    this._recalculateVersionDisplayString();
                }
            }
        );

        mLogSvc.get(this).debug(`Exiting Version Number Component Init. Version Display String is '${this.versionDisplayString}'`);
    }

    _recalculateVersionDisplayString() {
        let computedVersionDisplayString = computeVersionDisplayString({
            showVersionNumber: this.showVersionNumber,
            showVersionLabel: this.showVersionLabel,
            useSimplifiedLabel: this.useSimpleVersionLabel
        });

        mVersionDisplayString.set(this, computedVersionDisplayString);
        mLogSvc.get(this).debug(`Completed Version Display String Recalculate. Version Display String is '${this.versionDisplayString}'`);
    }

    get versionDisplayString() {
        return mVersionDisplayString.get(this);
    }

    get showTbVersion() {
        return (this.showVersionNumber || this.showVersionLabel);
    }

    get showVersionNumber() {
        return mShowVersionNumber.get(this);
    }

    set showVersionNumber(updatedVal) {
        let showVersionNumber = (updatedVal === true);
        mShowVersionNumber.set(this, showVersionNumber);
    }

    get showVersionLabel() {
        return mShowVersionLabel.get(this);
    }

    set showVersionLabel(updatedVal) {
        let showVersionLabel = (updatedVal === true);
        mShowVersionLabel.set(this, showVersionLabel);
    }

    get useSimpleVersionLabel() {
        return mUseSimplifiedVersionLabel.get(this);
    }

    set useSimpleVersionLabel(updatedVal) {
        let useSimpleLabel = (updatedVal === true);
        mUseSimplifiedVersionLabel.set(this, useSimpleLabel);
    }
}

VersionNumberComponentController.$inject = [ "$scope", "$log" ];
VersionNumberComponentController.controllerAs = "versionCtrl";

VersionNumberComponentController.template = `<span ng-if="${VersionNumberComponentController.controllerAs}.showTbVersion">{{${VersionNumberComponentController.controllerAs}.versionDisplayString}}</span>`;

const VersionNumberComponent = {
    name: "tbVersionNumber",
    config: {
        template: VersionNumberComponentController.template,
        bindings: {
            showVersionNumber: "<tbShowVersionNumber",
            showVersionLabel: "<tbShowVersionLabel",
            useSimpleVersionLabel: "<tbUseSimpleLabel"
        },
        controller: VersionNumberComponentController,
        controllerAs: VersionNumberComponentController.controllerAs
    }
};

export default angular
    .module("trackerbase-app.directives.version-number",[])
    .component(VersionNumberComponent.name, VersionNumberComponent.config)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/directives/CurrentVersion.js
// module id = aJvE
// module chunks = 1